// main.ts
import {downloadHandler} from "./Components/downloaderHandler"

let languageSelected = false

downloadHandler(languageSelected)
